<template>
    <div>
           <section slot="pdf-content" class="pdf-content">
            <!-- PDF Content Here -->
             <section  v-for="(equipesPaginationItem, indexPagination) in equipesPagination" 
             style="width:100%;">
             <section class="pdf-item"  style="width:100%"> 
                
                <pdf-entete 
                  :club="club" 
                  :tournoi="tournoi" 
                  :indexPagination="indexPagination"
                  :classement="equipesPagination"
                  :date="today()"
                  :mode="2"
                  :title="title"
                />
                <div style="text-align:center;width:100%;margin-top: 0px">
                 <div v-for="(poule, indexPoule) in equipesPaginationItem.poules" >
                    <div class="poule" v-if="displayEntetePoule(equipesPaginationItem, indexPagination, indexPoule)">
                        POULE {{indexPoule+1}}
                       
                    </div>
                    <div v-for="(equipe, indexEquipe) in equipesPaginationItem.poules[indexPoule]">
                    <div v-if="equipe.terrain" class="terrain">{{equipe.terrain.name}}</div>
                    <div class="ligne">
                        
                        <div class="groupe green" >
                            <div v-if="tournoi.options.mode=='FORME'  && equipe.joueurs.J1!=null" class="nameEquipe">
                                {{equipe.joueurs.J1.numero+1}} - {{nameEquipe(equipe, "joueurs")}}
                            </div>    
                            <div class="equipe" v-if="equipe.joueurs.J1!=null">
                                <joueurItem 
                                    :numero="equipe.joueurs.J1.numero" 
                                    :forme="tournoi.options.mode=='FORME'"
                                    :tournoi="tournoi" /> 
                            </div>
                            <div class="equipe" v-if="equipe.joueurs.J2!=null">
                                <joueurItem 
                                    :numero="equipe.joueurs.J2.numero" 
                                    :forme="tournoi.options.mode=='FORME'"
                                    :tournoi="tournoi" /> 
                                </div>
                            <div class="equipe" v-if="equipe.joueurs.J3!=null">
                                <joueurItem 
                                    :numero="equipe.joueurs.J3.numero" 
                                    :forme="tournoi.options.mode=='FORME'"
                                    :tournoi="tournoi" /> 
                            </div>
                        </div>
                        <div  class="VS">
                            <div v-if="equipe.state!='FINISH'">
                                -
                            </div>
                            <div v-if="equipe.state=='FINISH'">
                                {{equipe.score.joueurs}} - {{equipe.score.contre}}
                            </div>
                        </div>   
                        <div :class="existEquipe(equipe) ? 'groupe red' : 'groupe'" >
                        <div v-if="tournoi.options.mode=='FORME' && equipe.contre.J1!=null" class="nameEquipe">
                            {{equipe.contre.J1.numero+1}} - {{nameEquipe(equipe, "contre")}}
                        </div>  
                        <div class="equipe" v-if="equipe.contre.J1!=null">
                            <joueurItem 
                                :numero="equipe.contre.J1.numero" 
                                :forme="tournoi.options.mode=='FORME'"
                                :tournoi="tournoi" /> 
                            </div>
                            <div class="equipe" v-if="equipe.contre.J2!=null">
                            <joueurItem 
                                :numero="equipe.contre.J2.numero" 
                                :forme="tournoi.options.mode=='FORME'"
                                :tournoi="tournoi" /> 
                            </div>
                            <div class="equipe"  v-if="equipe.contre.J3!=null">
                            <joueurItem 
                                :numero="equipe.contre.J3.numero" 
                                :forme="tournoi.options.mode=='FORME'"
                                :tournoi="tournoi" /> 
                            </div>
                        </div>
                    </div>
                    </div>
                     </div>
                </div>
             </section>
                <div class="html2pdf__page-break" />
             </section>
           </section>
    </div>
</template>
<style scoped>
    .poule {
        border: gray thin solid;
        border-radius: 5px;
        color: black;
        padding: 3px;
        margin-top: 5px;
    }
    .nameEquipe {
        color: black;
        font-size: 12px;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
        
        vertical-align: top;
        padding: 5px;
    }
    .ligne {
        margin-top: 5px;
        
    }
    .red {
        border: rgb(187, 45, 45) thin solid;
        border-radius: 10px;
    }
    .green {
        border: rgb(27, 131, 61)  thin solid;
        border-radius: 10px;
    }
    .groupe {
        display:inline-block;
        width: 509px;
        height: 50px;
        text-align: center;
        vertical-align: top;
    }
    .equipe {
        display:inline-block;
        width: 160px;
      
        vertical-align: top;
        color: black;
        font-weight: bolder;
        padding: 5px;
    }
    .VS {
        display:inline-block;
        width: 50px;
        height: 50px;
        vertical-align: top;
        color: black;
        font-weight: bolder;
        
        padding-top: 25px;
        text-align: center;
        font-size: 12px;
        font-weight: bolder;
    }
   .pdf-item {
        padding-top: 20px;
        width: 100%;
        height: 750px;
        padding-left: 10px;
    }
    .pdf-content {
       margin: 0px;
       width: 100%;
    }
    .terrain {
        color: black;
        font-size: 14px;
        font-weight: bolder;
        border: thin solid black;
        padding: 3px;
        border-radius: 10%;
        width: 100px;
        left: 500px;
        margin-top: -5px;
        position: absolute;
        background-color: white;
    }
</style>
<script>
import joueurItem from "@/views/tournoi/export/joueurItem.vue"
import pdfEntete from '@/views/tournoi/export/pdfEntete.vue'
export default {
    props: ['club', 'equipesPagination', 'tournoi', 'title'],
    components: {
        joueurItem,
        pdfEntete
    },
    
    methods: {
        displayEntetePoule(equipesPaginationItem, indexPagination, indexPoule) {
            var display = false;
            
            
            if (this.tournoi.options.competition==3) {
                if (equipesPaginationItem.display) {
                    var nbPagePagination = (indexPagination+1);
                    var nbPagePool = (indexPoule+1) / 4;
                    nbPagePool = Math.ceil(nbPagePool);
                    if (nbPagePool==nbPagePagination)
                        display = true; 
                }
            }
            return display;
        },
        nameEquipe(equipe, vs) {
            if (equipe[vs].J1 == null)
                return "";
            else {
                
                if (typeof((this.tournoi.joueurs[equipe[vs].J1.numero])) != "undefined") {
                    var nameEquipe =  this.tournoi.joueurs[equipe[vs].J1.numero].pseudo;
                    if (typeof(this.tournoi.joueurs[equipe[vs].J1.numero].nameEquipe) != "undefined")
                        if (this.tournoi.joueurs[equipe[vs].J1.numero].nameEquipe != "")
                            nameEquipe = this.tournoi.joueurs[equipe[vs].J1.numero].nameEquipe;
                }
                return nameEquipe;
            }
        },
        existEquipe(equipe) {
            return equipe.contre.J1!=null ||  equipe.contre.J2!=null ||  equipe.contre.J3!=null
           
        },
        
        today() {
       var today = new Date();

      const options = {  year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute: 'numeric' };
      
       return today.toLocaleDateString(undefined, options);
     }
    }
}
</script>